

<template>
  <!-- Blog Area Start -->
  <section class="blog_area">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="site_heading">
            <h3 class="sub_title">always trend</h3>
            <h2 class="section_title">What’s Happening Your<br> Near City & Town</h2>
            <img src="../assets/img/section_delimiter.png" alt="img" class="section_devider">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="blog_item">
            <div class="blog_image">
              <router-link to="/news-details">
                <img src="../assets/img/blog_1.jpg" alt="blog"/>
              </router-link>
              <div class="post_date">
                <div class="date">13</div>
                <div class="month">Feb</div>
              </div>
            </div>
            <div class="blog_text">
              <div class="blog-meta">
                <p><i class="fas fa-tags"></i> <router-link to="/news-details">Pizza</router-link></p>
              </div>
              <h3>
                <router-link to="/news-details">Do You Think About Cheese Pizza Recipes?</router-link>
              </h3>
              <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut
                enim ad minima, quis nostrum onem</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="blog_item">
            <div class="blog_image">
              <router-link to="/news-details">
                <img src="../assets/img/blog_2.jpg" alt="blog"/>
              </router-link>
              <div class="post_date">
                <div class="date">13</div>
                <div class="month">Feb</div>
              </div>
            </div>
            <div class="blog_text">
              <div class="blog-meta">
                <p><i class="fas fa-tags"></i> <router-link to="/news-details">Pizza</router-link></p>
              </div>
              <h3>
                <router-link to="/news-details">Chicken Strips With New Ingridents Made.</router-link>
              </h3>
              <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut
                enim ad minima, quis nostrum onem</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="blog_item">
            <div class="blog_image">
              <router-link to="/news-details">
                <img src="../assets/img/blog_3.jpg" alt="blog"/>
              </router-link>
              <div class="post_date">
                <div class="date">13</div>
                <div class="month">Feb</div>
              </div>
            </div>
            <div class="blog_text">
              <div class="blog-meta">
                <p><i class="fas fa-tags"></i> <router-link to="/news-details">Pizza</router-link></p>
              </div>
              <h3>
                <router-link to="/news-details">Hot Chessyraw Pasta Make Creator Fact.</router-link>
              </h3>
              <p>Unknown printer took a galley of type and scrambled it to make a type specimen bookIt hasey survived Ut
                enim ad minima, quis nostrum onem</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Blog Area End -->
</template>
<script>
export default {
  name: 'BlogArea'
}
</script>



// WEBPACK FOOTER //
// src/components/BlogArea.vue